import { mapCompanyLicenseSummary } from 'app/pages/tpoPortal/commandCenterHome/CommandCenterHome/licenseCountdown.utils';
import { companyLicenseStateApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

// Broker-facing read — a 403 (DEV-3647 broker-auth gap) must degrade to the empty
// state, never trigger the global forbidden page-reload loop.
const SKIP_FORBIDDEN_CONFIG = { skipResponseInterceptor: { forbiddenError: true } };

export const COMMAND_CENTER_LICENSE_SUMMARY_ACTION_TYPE = createNamedActions(
  'commandCenterLicenseSummary',
  {
    SET_LICENSE_SUMMARY: 'SET_LICENSE_SUMMARY',
  },
);

export const getCompanyLicenseSummaryAction = catchAsyncActionError(
  ({ companyId }) =>
    async dispatch => {
      const { data } = await companyLicenseStateApi.getCompanyLicenseState({
        companyId,
        config: SKIP_FORBIDDEN_CONFIG,
      });

      return dispatch({
        type: COMMAND_CENTER_LICENSE_SUMMARY_ACTION_TYPE.SET_LICENSE_SUMMARY,
        payload: mapCompanyLicenseSummary(data ?? []),
      });
    },
);
